import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import SimpleDialog from "../../dialogs/SimpleDialog";
import CustomMultiText from "../../inputs/CustomMultiText";
import {valueRegisterNone} from "../../../../utils/RegisterUtils";
import Grid from "@mui/material/Grid";
import {useForm} from "react-hook-form";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {AppContext} from "../../../../App";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {Button, DialogActions, MenuItem, Paper, Typography} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {addStoricoPrenotazione, getStoricoPrenotazione} from "../../../../services/TamponiServices";
import CustomSelect from "../../inputs/CustomSelect";
import {useTheme} from "@mui/styles";
import { Skeleton } from '@mui/material';
import {lightBlue, orange} from "@mui/material/colors";
import moment from "moment";
import {getAccountInfo} from "../../../../utils/GenericUtils";

export const PrenotazioneDialog = ({idPrenotazione, setPrenotazione, selected, setSelected}) => {
	const classes = BaseStyle();
	const theme = useTheme();
	const {register, errors, handleSubmit, control} = useForm({
		mode: "onChange",
		defaultValues: {
			...selected,
			motivazione: selected.motivazione ? selected.motivazione.replaceAll("SISP", "").replaceAll("CTC", "").replaceAll(" ", "") : "Normale"
		}
	});
	const [state, dispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [submit, setSubmit] = useState(false);
	const appContext = useContext(AppContext);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true)
		addStoricoPrenotazione({
			...selected,
			...data,
			motivazione: data.motivazione === "Normale" ? null : "Prioritaria",
			active: false,
			prenotazioneTamponeId: idPrenotazione
		}, dispatch)
	}, [selected, dispatch, idPrenotazione])
	
	useEffect(() => {
		if (submit && !state.loadingAddStorico && state.errorAddStorico === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Prenotazione aggiornata", appContext.dispatch);
		} else if (submit && !state.loadingAddStorico && state.errorAddStorico !== "") {
			setSubmit(false);
			setOpenSnackbar("error", state.errorAddStorico, appContext.dispatch);
		}
	}, [state, submit, state.loadingAddStorico, state.errorAddStorico, appContext.dispatch])
	
	useEffect(() => {
		getStoricoPrenotazione(idPrenotazione, dispatch);
	}, [idPrenotazione, dispatch, submit])
	
	return (
        <React.Fragment>
            <SimpleDialog
				title={"Prenotazione " + idPrenotazione}
				open={idPrenotazione !== ""}
				handleClose={() => {
					setSelected({});
					setPrenotazione("");
				}}
				maxWidth={"md"}
				content={<form onSubmit={handleSubmit(onSubmit)}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							{
								state.loadingGetStorico ? <Skeleton/> :
									state.errorGetStorico !== "" ? "Err" :
										state.storicoPrenotazioni.length === 0 ? "Non c'è storico" :
											state.storicoPrenotazioni
												.sort((a, b) => new Date(a.dataUltimaModifica) - new Date(b.dataUltimaModifica))
												.map((item, index) => {
													return (
                                                        <Paper elevation={0} key={index} id={"paper-storico" + index}
														       style={{
															       backgroundColor: item.lastModify?.toLowerCase().includes("richiesta utente") ?
																       (theme.palette.mode === "light" ? orange[50] : orange[800]) :
																       (theme.palette.mode === "light" ? lightBlue[50] : lightBlue[800]),
															       borderRadius: 24,
															       padding: 16,
															       marginRight: 100,
															       marginTop: 16
														       }}>
                                                            <Typography variant={"subtitle2"} color={"textSecondary"}>
																<b>{item.lastModify}</b> in
																data: {moment(item.dataCreazione).format("DD/MM/YYYY - HH:mm")}
															</Typography>
                                                            <Typography variant={"subtitle1"}>
																{item.note.replaceAll(/#(\S*)/g, "")}
															</Typography>
                                                        </Paper>
                                                    );
												})
							}
						</Grid>
						<Grid item xs={12}>
							<CustomMultiText
								inputRef={register(valueRegisterNone)}
								label={"Note"}
								autoFocus={false}
								rows={5}
								name={"note"}
								error={errors["note"]}
							/>
						</Grid>
						<Grid item xs={12}>
							<CustomSelect
								control={control}
								rules={valueRegisterNone}
								name={"motivazione"}
								label={"Priorità"}
								autoFocus={false}
								none={true}
								defaultValue={"Normale"}
								noneValue={""}
								error={errors["motivazione"]}
							>
								<MenuItem value={"Normale"}>
									Normale (verrà comunque gesita)
								</MenuItem>
								<MenuItem value={"Prioritaria"}>
									Prioritaria (verrà gestita con priorità)
								</MenuItem>
							</CustomSelect>
						</Grid>
						<Grid item xs={12}>
							<CustomSelect
								name={"stato"}
								label={"Stato richiesta"}
								control={control}
								defaultValue={""}
								autoFocus={false}
								none={true}
								noneValue={""}
								rules={{required: true}}
								error={errors["stato"]}
							>
								{["Richiesta inserita", "Prenotazione conclusa", "Prenotazione annullata", "Gestita", "Non presentato"].map((val) => {
									return (
										<MenuItem value={val} key={val}
										          disabled={val === "Prenotazione conclusa" || val === "Gestita"}>
											{val}
										</MenuItem>
									);
								})}
							</CustomSelect>
						</Grid>
					</Grid>
				</form>}
				actions={<DialogActions>
					<Button size={"small"} variant={"text"} className={classes.roundButton} onClick={() => {
						setSelected({});
						setPrenotazione("");
					}}>
						<b>Chiudi</b>
					</Button>
					<Button size={"small"} variant={"contained"} color={"primary"} disableElevation disabled={submit || getAccountInfo().roles?.includes("ROLE_SP_301_H")}
					        className={classes.roundButton} onClick={handleSubmit(onSubmit)}>
						<b>Aggiorna informazioni</b>
					</Button>
				</DialogActions>}
			/>
        </React.Fragment>
    );
};
